import Kindle from '../shared/kindle.js';
import m from 'mithril'
import "../shared/util.js"

import TabController from '../shared/sidebar.js';

import FuzzyClock from '../fuzzy/fuzzy.js';
import Weather from '../weather/weather-view.js';
import AgendaRootContainer from '../agenda/agenda-view.js';
import TaskRootContainer from '../tasks/tasks-view.js';
import SettingsContainer from '../shared/settings.js';

import Google from '../shared/googleapi.js';
import StatusBar from '../shared/statusbar.js';
import Cookies from '../shared/cookie.js';
import IG from '../ig/ig.js';



window.onscroll = function() {
  var scrolled = document.body.scrollTop > 10 || document.documentElement.scrollTop > 10;
  document.body.classList.toggle("scrolled", scrolled)
}

document.redraw = function(flashNow) {
  m.redraw();
  Kindle.refreshScreen(flashNow);
}

document.addEventListener("DOMContentLoaded", function() {
  var interfaceStyle = Cookies.get("interfaceStyle") || 'light';
  if (interfaceStyle == 'auto') interfaceStyle = 'light'
  document.body.classList.add('' + interfaceStyle);

  var root = document.getElementById("tab-root")
  m.mount(root, RootContainer) 
});


  var menuContent = m("div.menu-div", 
    m('h2', "Options under construction")
  );
  

  var RootContainer = function(vnode) {

    var screensaverType = Cookies.get("screenSaverType") || "none";
    var screensaverActive = false;
    var screensaverTimeout = null;
    var screensaverDuration = 5 * 60 * 1000;
    

    function activateScreensaver {
      screensaverActive = true;
      m.redraw();
    };

    function setScreensaver() {
      clearTimeout(screensaverTimeout);
      if (screensaverType != "none") {
        screensaverTimeout = setTimeout(activateScreensaver, screensaverDuration)
      }
    };

    setScreensaver();
    
    function handleClick(event) {

      event.stopImmediatePropagation();
      event.preventDefault();
      screensaverActive = false;
      setScreensaver();
    };

    return {
      view: function(vnode) {
        var tabs = [
          {id: "time", title:"Time", content:FuzzyClock},
          {id: "overview", title:"Overview", content:OverviewContainer},
          {id: "weather", title:"Weather", content:Weather},
          {id: "schedule", title:"Schedule", content:AgendaRootContainer},
          {id: "tasks", title:"Tasks", content:TaskRootContainer},
          {id: "board", title:"Message Board", content:MessageBoard},
          {id: "instagram", title:"Instagram", content:IG},
          {id: "settings", title:"Settings", content:SettingsContainer},
        ];
      
        if (screensaverActive) {
          var saverNode = undefined;
          if (screensaverType == "ig") {
            saverNode = m(IG);
          } else {
            saverNode = m(FuzzyClock);
          }
          return m("div#root-container.screensaver", {key:"root", onclick:handleClick}, saverNode);
        }

        return m("div#root-container", {key:"root", onclick:handleClick}
          m(TabController, {tabs: tabs, menu:null})
        );
      }
    }
};


var OverviewContainer = {
  view: function(vnode) {
    return m("div#overview-container",
      m(StatusBar),
      m(FuzzyClock, {class:"widget"}),
      m(Weather, {class:"widget"}),
      m(AgendaRootContainer, {class:"widget"}),
      m(TaskRootContainer, {class:"widget"}),
      
    );
  }
}


var MessageBoard = {
  view: function(vnode) {
    return m('div', {contenteditable:true, class: "h1"})
      
    );
  }
}